export interface NetworkMember {
  createdAt: string;
  id: number;
  memberId: number;
  networkId: number;
  peswitch: NetworkPESwitchEnum;
  jobsDistributionWay: JobsDistributionWayEnum;
  marketplaceNetworks: NetworkMember[];
  displayOnJobEstimator?: boolean;
  /**
   * PRD-471: Industry Average only. When on (default), the org is dropped from the candidate
   * suppliers at job config start.
   */
  excludeInJobConfig?: boolean;
  /**
   * PRD-471: sub-option of `excludeInJobConfig`, only shown while it is off. When on (default),
   * job config offers a "Contact Revshop" button instead of Add to Cart.
   */
  disableAddToCartInJobConfig?: boolean;
}

export interface UpdateNetworkMember extends PartialMember {
  marketplaceNetworkOrgIds?: number[];
}

export enum JobsDistributionWayEnum {
  PO = 'PO',
  RFM = 'RFM',
}

type OrgNetworkMember = {
  memberId: number;
  memberName: string;
};
export interface OrgNetwork {
  members: OrgNetworkMember[];
  networkId: number;
  networkName: string;
}

export enum NetworkPESwitchEnum {
  PRIVATE = 'PRIVATE',
  LIVE = 'LIVE',
}

export type PartialMember = Partial<NetworkMember>;
